import { loadable } from '@change-corgi/core-react/loadable';

import type { AppRoute } from '#src/shared/routes';

import { Loading } from '#src/app/shared/routes';

export const ROUTES: readonly AppRoute[] = [
	{
		id: 'admin-comms-orders-audience-builder-v2',
		path: '/admin/comms/send_orders/:id/audience_builder/v2',
		component: loadable(
			async () => import(/* webpackChunkName: "pages/admin-comms-ordersV2-audienceBuilder" */ './index'),
			{
				exportName: 'AdminCommsOrdersAudienceBuilderV2',
				fallback: Loading,
			},
		),
		frame: true,
		restrictedAccess: {
			authOnly: true,
			role: ['staff'],
		},
		ssr: {
			// switch this to true to enable SSR
			enabled: false,
			seo: false,
		},
	},
];
